<template lang="pug">
#gestao-contratos-originacao
    BaseHeader(
            titulo='Gestão de contratos de originação',
            icon='mdi mdi-file-plus',
            btnTexto='Novo contrato',
            :exibeBotao='true'
            @btnHeaderClicado='novoContrato'
        )

    .view-container.margen-bottom-pages
        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(
                @emitFiltros="adicionarFiltros")

        .bloco-infor-dados
            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Contratos não visualizados"
                    :numero="totalContratosOriginacao.totalNaoVisualizado"
                )
                    template(slot='icone')
                        i.mdi.mdi-eye-off-outline

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Contratos visualizados"
                    :numero="totalContratosOriginacao.totalVisualizado"
                )
                    template(slot='icone')
                        i.mdi.mdi-eye-outline

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Contratos em cadastramento"
                    :numero="totalContratosOriginacao.totalEmCadastramento"
                )
                    template(slot='icone')
                        i.mdi.mdi-pen-plus

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Contratos concluídos"
                    :numero="totalContratosOriginacao.totalConcluido"
                )
                    template(slot='icone')
                        i.mdi.mdi-check-circle-outline

        .secao-listagem-filtro
            .titulo-listagem
                h3 Listagem de contratos cadastrados

            .check-campos-erros(v-show="false")
                el-checkbox(
                    v-model="CheckListagemContratoErro"
                    @change="contratosErros")
                    | Mostrar apenas contratos em alerta

        .bloco-novos-contratos-tabela
            TabelaGestaoContratoOriginacaoEmpresa(
                    :tabelaData="contratosTabela"
                    :carregando="carregandoTabela"
                    :paginacao="paginacao"
                    :totalizador="totalizador"
                    @mudarPagina='mudarPagina'
                    @ordenarTabela="ordenarTabela"
                    @removerContrato="removerContrato")

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInforDadosGestao from '@/components/contratosOriginacao/BlocoInforDadosGestao';
import SkeletonBlocoInforDadosGestao from '@/components/contratosOriginacao/SkeletonBlocoInforDadosGestao.vue';
import TabelaGestaoContratoOriginacaoEmpresa from '@/components/contratosOriginacao/TabelaGestaoContratoOriginacaoEmpresa';
import BlocoPesquisaFiltros from '@/components/contratosOriginacao/BlocoPesquisaFiltros';
import ServiceRastreabilidadeEmpresa from '@/services/RastreabilidadeEmpresa';

export default {
    name: 'GestaoContratosOriginacao',
    components: {
        BaseHeader,
        BlocoInforDadosGestao,
        SkeletonBlocoInforDadosGestao,
        TabelaGestaoContratoOriginacaoEmpresa,
        BlocoPesquisaFiltros
    },
    data() {
        return {
            totalContratosOriginacao: {
                totalNaoVisualizado: null,
                totalVisualizado: null,
                totalEmCadastramento: null,
                totalConcluido: null,
                totalAguardandoPreenchimento: null
            },
            contratosTabela: [],
            paginacao: {},
            totalizador: '',
            params: {
                page: 0,
                size: 20,
                sort: 'volumeContratado',
                por: 'desc'
            },
            filtro: {
                numeroContrato: '',
                dataContrato: '',
                idsCultura: [],
                idsSafra: [],
                codigosStatus: [],
                contratosComAlerta: false
            },
            skeletonBlocoInforDados: true,
            CheckListagemContratoErro: false,
            carregandoTabela: false
        };
    },
    mounted() {
        this.buscarTotalizadores();
        this.buscarContratosEmpresa();
    },
    methods: {
        async buscarTotalizadores() {
            try {
                const { data } = await ServiceRastreabilidadeEmpresa.totalizadores();
                this.totalContratosOriginacao = {...data};
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível buscar os dados de totalizadores.'
                });
            }
            this.skeletonBlocoInforDados = false;
        },
        async buscarContratosEmpresa() {
            this.carregandoTabela = true;
            try {
                const { data } = await ServiceRastreabilidadeEmpresa.contratos(this.filtro, this.params);
                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.totalizador = data.totalizador;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível buscar os dados de contrato.'
                });
            }
            this.carregandoTabela = false;
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarContratosEmpresa();
        },
        ordenarTabela(column) {
            this.params.sort = column.prop;
            this.params.por = column.order;
            this.buscarContratosEmpresa();
        },
        adicionarFiltros(filtro) {
            this.filtro.dataContrato = filtro.dataCadastro;
            this.filtro.idsCultura = filtro.culturas;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.numeroContrato = filtro.pesquisa;
            this.buscarContratosEmpresa();
        },
        contratosErros() {
            
            if (this.CheckListagemContratoErro) {
                this.filtro.contratosComAlerta = true;
            } else {
                this.filtro.contratosComAlerta = false;
            }
            this.buscarContratosEmpresa();
        },
        novoContrato() {
            this.$router.push({ name: 'CadastrarContratoOriginacaoEmpresa' });
        },
        async removerContrato(codContrato) {
            try {
                const msg = await ServiceRastreabilidadeEmpresa.removerContrato(codContrato);
                this.buscarContratosEmpresa();
                this.$notify.success({
                    message: msg.data
                });
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível remover o contrato.'
                });
            }
        }
    }
};

</script>

<style lang="scss">
#gestao-contratos-originacao {
    .bloco-infor-dados {
        display: flex;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
        flex-wrap: wrap;
        & > div {
            flex-grow: 1;
        }
    }
    .bloco-novos-contratos-preenchimento, .bloco-infor-dados, .bloco-pesquisa-filtros, .bloco-novos-contratos-tabela{
        margin-top: 20px;
    }
    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
    .secao-listagem-filtro {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;
        .el-checkbox__label, .titulo-listagem h3 {
            font-weight: bold;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 49%;
    }
}
</style>
